import { useEffect, useRef, useState } from "react";
import Dialog from "../components/Dialog";

export default function usePdfPreview() {
  const [pdf, setPdf] = useState(null);
  const current = useRef(null);
  const close = () => { if (current.current) URL.revokeObjectURL(current.current); current.current = null; setPdf(null); };
  useEffect(() => () => { if (current.current) URL.revokeObjectURL(current.current); }, []);
  const openPDF = (response, name = "document.pdf") => {
    if (current.current) URL.revokeObjectURL(current.current);
    const url = URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
    current.current = url; setPdf({ url, name });
  };
  const preview = pdf && <Dialog title={`Aperçu : ${pdf.name}`} size="max-w-5xl" onClose={close} footer={<><a className="btn-secondary" href={pdf.url} target="_blank" rel="noopener noreferrer">Ouvrir dans un onglet</a><a className="btn-primary" href={pdf.url} download={pdf.name}>Télécharger le PDF</a></>}><iframe title="Aperçu PDF" src={pdf.url} className="h-[65vh] w-full border-0" /><p className="mt-2 text-xs text-gray-500">Si votre navigateur ne montre pas l'aperçu, ouvrez ou téléchargez le PDF.</p></Dialog>;
  return { openPDF, preview };
}
